module.exports = __webpack_public_path__ + "static/media/microblog.c8854ea5.svg";